export const SLOT_FAMILY_HANDICAP = 'SLOT_FAMILY_HANDICAP';
export const SLOT_FAMILY_SINGLE_ONE_LINE_3W = 'SLOT_FAMILY_SINGLE_ONE_LINE_3W';
export const SLOT_FAMILY_SINGLE_ONE_LINE_2W = 'SLOT_FAMILY_SINGLE_ONE_LINE_2W';
export const SLOT_FAMILY_SINGLE_MULTI_LINE = 'SLOT_FAMILY_SINGLE_MULTI_LINE';
export const SLOT_FAMILY_TOTAL = 'SLOT_FAMILY_TOTAL';
export const SLOT_FAMILY_CORRECT_SCORE_SINGLE_BET = 'SLOT_FAMILY_CORRECT_SCORE_SINGLE_BET';
export const SLOT_FAMILY_CORRECT_SCORE_MULTI_BETS = 'SLOT_FAMILY_CORRECT_SCORE_MULTI_BETS';

export type SLOT_FAMILY = string;
